var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseView',[(!_vm.isReady)?_c('Loading'):_c('NewProfileFlow',{attrs:{"invitation":_vm.invitation,"my-profile-adapter":_vm.myProfileAdapter},on:{"show-message":function($event){return _vm.showMessage($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }